import { Box, Container, Typography } from "@mui/material";
import React from "react";
import Slider from "react-slick";
import partnerLogos from "../../../utils/common/partnerLogos";

const PartnersSection = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 400,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <Box
      component="section"
      sx={{
        bgcolor: "background.dark",
        py: { xs: 6, md: 8 },
        px: { xs: 2, md: 12.5 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 4, md: 6.25 },
      }}
    >
      <Typography
        variant="h2"
        color="text.light"
        sx={{
          fontFamily: "Jost-Bold, Montserrat",
          fontWeight: 700,
          fontSize: { xs: 36, sm: 44, md: 64 },
          letterSpacing: { xs: "-2px", md: "-5px" },
          width: "100%",
          textAlign: "center",
        }}
      >
        OUR PARTNERS
      </Typography>

      <Container maxWidth="lg" sx={{ px: { xs: 1.5, md: 0 } }}>
        <Slider {...settings}>
          {partnerLogos.map((logo) => (
            <Box
              key={logo.id}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: { xs: 1, md: 2 },
              }}
            >
              <Box
                component="img"
                src={logo.src}
                alt={logo.alt}
                sx={{
                  width: { xs: 120, md: 155 },
                  height: { xs: 110, md: 143 },
                  objectFit: "contain",
                }}
              />
            </Box>
          ))}
        </Slider>
      </Container>
    </Box>
  );
};

export default PartnersSection;
